export const totalInc = (state) => {
    let measurement =getMeasurement(state);
    let sumofmeasurement = 0;
    if(measurement){
        measurement.map(function(data){
            sumofmeasurement += calculateMeasurement(data.step,Number(data.val));
        })
        return Math.ceil(Number(sumofmeasurement?sumofmeasurement:0));
    }
    return Math.ceil(Number(sumofmeasurement));
}

export const inputedMeasurement = (state) => {
   return getMeasurement(state);
}

export const showOnlyProductList = (state) => {
    return !Object.hasOwn(state.product,'key');
    // return state.products.length > 0 & !Object.hasOwn(state.product,'key');
}
export const totalPrice = (state) => {
    return Number(state.qty) * Number(state.price);
}
export const totalQty = (state) => {
    return Number(state.qty);
}

function getMeasurement(state) {
    switch (state.configuration.id) {
        case 1:
            return [state.config1_input_one]
            break;
        case 2:
            return [state.config2_input_one,
            state.config2_input_two,
            state.config2_input_three
            ]
            break;
        case 3:
            return [state.config3_input_one,
            state.config3_input_two
            ]
            break;
        case 4:
            return [state.config4_input_one,
            state.config4_input_two, state.config4_input_three
            ]
            break;
        case 5:
            return [state.config5_input_one,
            state.config5_input_two
            ]
            break;
        case 6:
            return [state.config6_input_one,
            state.config6_input_two
            ]
            break;
        case 7:
            return [state.config7_input_one,
            state.config7_input_two,
            state.config7_input_three
            ]
            break;
        case 8:
            return [state.config8_input_one,
            state.config8_input_two
            ]
            break;

        default:
            break;
    }
}

function calculateMeasurement(configType,val) {
    switch (configType) {
        case "config1_input_one":
          return Number(val) * 1;
          break;

        case "config2_input_one":
            // HEIGHT
          return (Number(val)-0.5)*2
          break;
        case "config2_input_two":
            // LENGTH
          return (Number(val)-0.5)*4
          break;
        case "config2_input_three":
            // WIDTH
            return (Number(val)-1)
          break;

        case "config3_input_one":
            // WIDTH
            return (Number(val)-1)
          break;
        case "config3_input_two":
            // LENGTH
            return (Number(val)-0.5)*4
          break;

        case "config4_input_one":
            // HEIGHT
            return (Number(val)-0.5)*2
          break;
        case "config4_input_two":
            // LENGTH
            return (Number(val)-0.5)*2
          break;
        case "config4_input_three":
            // WIDTH
            return (Number(val)-0.25)
          break;

        case "config5_input_one":
            // LENGTH
            return (Number(val)-0.5)*2
          break;
        case "config5_input_two":
            // WIDTH
            return (Number(val)-0.25)
          break;

        case "config6_input_one":
            // WIDTH
            return (Number(val)-1)  
          break;
        case "config6_input_two":
            // LENGTH
            let formula_one = Number(val)-0.5;
            let formula_two = Number(val)-1.5;
            return (formula_one + formula_two *3)
          break;

        case "config7_input_one":
            // HEIGHT
            return (Number(val)-0.5)*2
          break;
        case "config7_input_two":
            // WIDTH
            return Number(val)-1
          break;
        case "config7_input_three":
            // LENGTH
            let formula7_one = Number(val);
            let formula7_two = Number(val)-0.5;
            return (formula7_one + formula7_two *2)
          break;

        case "config8_input_one":
          return 0
          return "WIDTH"
          break;
        case "config8_input_two":
            // LENGTH
            return Number(val)*4
          break;


        default:
          break;
      }
}


export const completedSection= (state,getters) => {
  let {configuration, products,product, price} = state;
  let {totalPrice} = getters;
  let completedSteps = [];

  if(Object.keys(configuration).length >0){
      completedSteps.push(1);
  }

  if(products.length > 0 && Object.keys(product).length >0){
      completedSteps.push(2);
  }

  if(totalPrice > 0){
      completedSteps.push(3);
  }
  return completedSteps;
}

